import { useI18n } from '@/contexts/I18nContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useI18n();

  return (
    <div className="rounded-md border bg-background/95 px-2 py-1 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground">{t('language_label')}</span>
        <Select value={language} onValueChange={(v) => setLanguage(v as 'en' | 'fr' | 'ar')}>
          <SelectTrigger className="h-8 min-w-[120px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="en">{t('language_english')}</SelectItem>
            <SelectItem value="fr">{t('language_french')}</SelectItem>
            <SelectItem value="ar">{t('language_arabic')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
